import {
  Collapse,
  MediaQuery,
  FontWeight,
  BodyHeavy,
  CaptionHeavy,
  Caption,
  TextSkeleton,
  Colors,
} from '@pelando/components';
import styled from 'styled-components';

export const StoreDetailsContainer = styled.div`
  grid-area: knowmore;
  color: rgb(${({ theme }) => theme.colors.Alpha});
  margin-bottom: 16px;
  background: rgb(${({ theme }) => theme.colors.Juliet});
  padding: 12px 24px 24px 24px;
  margin-left: -16px;
  margin-right: -16px;
  width: 100vw;

  @media ${MediaQuery.SCREEN_MD_UP} {
    background: transparent;
    padding: 0;
    padding-bottom: 24px;
    width: 100%;
    margin-left: unset;
    margin-right: unset;
  }
`;

export const StoreDetailsTitle = styled.h2`
  ${BodyHeavy};
  margin-bottom: 10px;
`;

export const StoreDetailsRating = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const StoreDetailsRatingText = styled.p`
  ${CaptionHeavy};
  margin-right: 6px;
`;

export const StoreDetailsTotalRating = styled.p`
  ${Caption};
  color: rgb(${Colors.Gray});
  margin-left: 6px;
`;

export const StoreDetailsCollapse = styled(Collapse)`
  & > div {
    ${Caption};

    p {
      margin: 0;
    }

    h4 {
      font-weight: ${FontWeight.REGULAR};
    }

    @media ${MediaQuery.SCREEN_MD_UP} {
      &[aria-hidden='true'] {
        max-height: 100%;
      }
    }
  }
  & > button {
    @media ${MediaQuery.SCREEN_MD_UP} {
      display: none;
    }
  }
`;

export const StoreDetailsSkeletonContainer = styled.div`
  grid-area: knowmore;
  padding: 12px 8px 24px;
  margin-top: 16px;
  margin-bottom: 24px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0;
    margin-top: 0;
    padding-top: 12px;
    padding-bottom: 24px;
    margin-bottom: 222px;
  }
`;

export const StoreDetailsTitleSkeleton = styled(TextSkeleton)`
  display: block;
  height: 20px;
  max-width: 143px;
  border-radius: 12px;
  margin-bottom: 10px;
`;

export const StoreDetailsSubtitleSkeleton = styled(TextSkeleton)`
  display: block;
  height: 24px;
  max-width: 243px;
  border-radius: 12px;
`;
